import CustosGeraisTotalizadorView from "../../components/gestaoOrcamentaria/CustosGeraisTotalizadorView";

export default function CustosGerais() {
  return <CustosGeraisTotalizadorView tituloModulo="Custos Gerais" />;
}
